<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12.9297 1.41508H1.41508V12.9297H12.9297V1.41508ZM0 0V14.3448H14.3448V0H0Z"
    fill="currentColor" />
</svg>
